const homePagePayload = {
  banners: {
    enable: true,
    count: 5,
  },
  products: {
    enable: true,
    count: 8,
  },
  topSellerProducts: {
    enable: true,
    count: 3,
  },
  testimonials: {
    enable: true,
    count: 3,
  },
  blogs: {
    enable: true,
    count: 3,
  },
  coupons: {
    enable: true,
  },
  categories: {
    enable: true,
    count:4 ,
  },
};

export default homePagePayload;
